import React, { useState, useEffect } from 'react';
import api from '../../api/auth';

const StudentCompositions = () => {
  const [compositions, setCompositions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompositions();
  }, []);

  const fetchCompositions = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await api.get('/student/compositions', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCompositions(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => {
    if (!d) return '-';
    try { return new Date(d).toLocaleDateString('fr-FR'); } catch { return d; }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#2C3E50]">🧪 Mes compositions</h1>
        <p className="text-gray-500">Consultez les compositions programmées pour votre classe</p>
      </div>

      <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4">
        <p className="text-sm text-blue-700">
          ℹ️ <strong>Information :</strong> Ces compositions sont planifiées par l'administration.
          Préparez-vous bien !
        </p>
      </div>

      {loading ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <div className="animate-pulse space-y-3">
            <div className="h-4 bg-gray-200 rounded w-1/4 mx-auto"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
          </div>
        </div>
      ) : compositions.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <p className="text-4xl mb-3">📭</p>
          <p className="text-lg font-medium text-gray-700 mb-2">Aucune composition programmée</p>
          <p className="text-sm text-gray-500">Revenez plus tard pour voir les compositions à venir.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {compositions.map((c) => (
            <div key={c.id} className="bg-white rounded-xl shadow-md overflow-hidden border-l-4 border-[#E67E22]">
              <div className="p-5">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-lg font-bold text-[#2C3E50]">{c.title}</h3>
                  <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                    🟢 Programmée
                  </span>
                </div>

                <div className="space-y-2 text-sm text-gray-700">
                  <p>📚 <strong>{c.subject}</strong></p>
                  <p>📅 <strong>{formatDate(c.date)}</strong></p>
                  <p>⏰ <strong>{c.start_time} - {c.end_time}</strong></p>
                  {c.room && <p>🏛️ Salle : <strong>{c.room}</strong></p>}
                  <p>⚖️ Coefficient : <strong>{c.coefficient}</strong></p>
                </div>

                {c.topics && (
                  <div className="mt-4 bg-orange-50 rounded-lg p-3">
                    <p className="text-xs font-bold text-[#E67E22] mb-1">📖 Programme à réviser :</p>
                    <p className="text-xs text-gray-700">{c.topics}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentCompositions;